import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Book20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 1.75C4.08579 1.75 3.75 2.08579 3.75 2.5C3.75033 2.91393 4.08599 3.25 4.5 3.25L17 3.25C17.4142 3.25 17.75 3.58579 17.75 4V19C17.75 19.4142 17.4142 19.75 17 19.75H5C3.48122 19.75 2.25 18.5188 2.25 17V2.5C2.25 1.25736 3.25736 0.25 4.5 0.25H17V1.75L4.5 1.75ZM3.75 17V4.62197C3.98458 4.70488 4.23702 4.75 4.5 4.75L12 4.75V10L13 9L14 10V4.75H16.25V18.25H5C4.30964 18.25 3.75 17.6903 3.75 17Z'
      fill='currentColor'
    />
  </Svg>
);

Book20.displayName = 'Book20';
export default Book20;
